import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=a86c5310"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a86c5310')) {
      api.createRecord('a86c5310', component.options)
    } else {
      api.reload('a86c5310', component.options)
    }
    module.hot.accept("./DashboardLayout.vue?vue&type=template&id=a86c5310", function () {
      api.rerender('a86c5310', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Layout/DashboardLayout.vue"
export default component.exports